export default "__VITE_ASSET__DG6mDfn3__"